import CounselorRequestModel from './CounselorRequestModel';
import UserModel from './UserModel';
import moment from 'moment';

export default class AppointmentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.existing_patient = data.existing_patient || false;
    this.counselor = new CounselorRequestModel(data.counselor);
    this.user = data.user ? new UserModel(data.user) : null; // student

    this.start_time = data.start_time ? moment(data.start_time).toDate() : null;
    this.end_time = data.end_time ? moment(data.end_time).toDate() : null;

    this.is_meeting_host = data.meeting_start_url && data.meeting_start_url.length > 0;

    this.payment = data.payment || null;
    this.meeting_id = data.meeting_id || 0;

    this.is_appointment_request = 'approved' in data;
    this.approved = data.approved || null;
    this.canceled = data.canceled || null;
    
    if (data.cronofy_event) {
      this.cronofy_event_id = data.cronofy_event.id || null;
    }
  }


  get studentDisplayName() {
    if (this.user) {
      return this.user.fullName;
    }
    return 'New Student';
  }

  get studentID() {
    if (this.user) {
      return this.user.id;
    }
    return 0;
  }

  get counselorName() {
    if (this.counselor && this.counselor.user) {
      return this.counselor.user.fullName;
    }
    return '';
  }

  get studentEmail() {
    return (this.user && this.user.email) || 'N/A';
  }

  get status() {
    if (this.payment) {
      if (this.payment.credit_used) {
        return 'PAID Credit';
      }
      if (this.payment.stripe_payment_intent_id) {
        return 'PAID CC';
      }
      if (this.payment.status === 'pending') {
        return 'Not Paid';
      }
      return this.payment.status;
    }

    if (this.is_appointment_request) {
      if(this.canceled){
        return 'Declined'
      } else  if (this.approved) {
        return 'Approved';
      } else {
        return 'Pending';
      }
    }

    return 'Free';
  }
}
